export default "__VITE_ASSET__DtPLYx97__"